import { api } from '../utils/request'
export const blog = async (query) => {
    const resp = await api({
        endpoint: '/blog',
        method: 'GET',
        query

    })
    return resp
}

export const blogById = async (id) => {
    const resp = await api({
        endpoint: `/blog/${id}`,
        method: 'GET',


    })
    return resp
}

export const blogTopic = async (query) => {
    const resp = await api({
        endpoint: '/blogTopic',
        method: 'GET',
        query

    })
    return resp
}